import { createUseAppTranslation } from '@sib/i18n';

export const useAppTranslation = createUseAppTranslation('documents');
